import { sendGoogleEvent } from '@html/_common/utils';

export default function initiateStartPlanningYourTour(eventCategory) {
  const elementGAEvent = 'Start planning your tour - click';
  $('.js-ao-tour-start-planning-your-tour__cta-brochure').click(() => {
    sendGoogleEvent(eventCategory, elementGAEvent, 'Download Brochure');
  });
  $('.js-ao-tour-start-planning-your-tour__cta-ask').click(() => {
    sendGoogleEvent(eventCategory, elementGAEvent, 'Ask a Travel Expert');
  });
  $('.js-ao-tour-start-planning-your-tour__cta-share').click(() => {
    sendGoogleEvent('TDP (Travel Agent) share tour', 'Click the "Share link" CTA', 'Travel Agent');
  });
}
